import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const assetUrl = (p) => (p && p.startsWith("/") ? `${BACKEND}${p}` : p || "");
